export enum SubmissionMode {
  All = 'all',
  Individual = 'individual',
}
